import { Header } from '@components/Organisms/Header';
import { WelcomeMessage } from '@components/WelcomeMessage/index';
import LanguageSwitcher from '@components/TheHeader/LanguageSwitcher';
import { HomepageNavigation } from '@components/Homepage/HomepageNavigation';
import { useStoreState } from 'easy-peasy';
import { selectorCustomer } from '@model/Customer';

export const HomepageHeader = () => {
  const { companyName } = useStoreState(selectorCustomer);

  return (
    <div className="c-homepage-header rev-o-container rev-o-container--full">
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-o-col-12 rev-u-px-16 rev-u-py-16">
            <Header
              logo={`${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-group-logo.svg`}
            >
              <WelcomeMessage
                labelClassName={
                  __ENVIRONMENT_CONFIG__.IS_THEME_AKI
                    ? 'typo-text-label--aki'
                    : undefined
                }
                nameClassName={
                  __ENVIRONMENT_CONFIG__.IS_THEME_AKI
                    ? 'typo-text-body--aki'
                    : undefined
                }
              />

              <LanguageSwitcher />
            </Header>
          </div>
        </div>

        {!!companyName && (
          <div className="rev-o-grid">
            <div className="rev-o-col-12 rev-u-px-16">
              <p className="c-homepage-header__company rev-o-typo-heading-3">
                {companyName}
              </p>
            </div>
          </div>
        )}

        <div className="rev-o-grid">
          <div className="rev-o-col-12 rev-u-px-16">
            <HomepageNavigation />
          </div>
        </div>
      </div>
    </div>
  );
};
